import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import PaymentVoucherIndexPage from '../containers/PaymentVouchers'

import appActions from '../redux/app/actions'

const { changeCurrent } = appActions

const PaymentVouchersPage = ({
  location,
	match
}) => {
  const dispatch = useDispatch()
	const current = useSelector(state => state.getIn(['App', 'current'])).toJS()
	const { pathname } = location

	useEffect(() => {
		if (current[0] !== 'payment_vouchers') {
			dispatch(changeCurrent(['payment_vouchers']))
		}
	}, [pathname])

	const path = match.url

  return (
		<Switch>
			<Route path={`${path}/`} component={PaymentVoucherIndexPage} exact />
		</Switch>
  )
}

PaymentVouchersPage.propTypes = {
  location: PropTypes.object.isRequired,
	match: PropTypes.object.isRequired
}

PaymentVouchersPage.defaultProps = {}

export default PaymentVouchersPage
